import { Injectable } from '@angular/core';
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { guid } from '@datorama/akita';
import { AkitaNgFormsManager } from '@datorama/akita-ng-forms-manager';
import { FormController } from '@lycoris-nubila/ngx-lycoris';

import { IUserReference } from 'user/user-reference';

@Injectable()
export class CoachSettingsGeneralFormController extends FormController<any> {
	constructor(private _fb: FormBuilder, formsManager: AkitaNgFormsManager) {
		super(
			formsManager,
			`coach-settings-general-${guid()}`,
			_fb.group({
				newCertificate: _fb.group({
					id: [null],
					institution: ['', Validators.required],
					range: [null, [Validators.required]],
					name: ['', Validators.required],
				}),
				newDiploma: _fb.group({
					id: [null],
					institution: ['', Validators.required],
					range: [null, [Validators.required]],
					name: ['', Validators.required],
				}),
				sessionPrice: _fb.group({
					amount: [null],
					currency: ['EUR', Validators.required],
				}),
				planPrice: _fb.group({
					amount: [null],
					currency: ['EUR', Validators.required],
				}),
				certificates: _fb.array([]),
				diplomas: _fb.array([]),
				biography: [''],
				firstName: ['', Validators.required],
				lastName: ['', Validators.required],
				timeZone: [null],
				phoneNumber: [],
				birthDate: [],
				sectors: [[]],
				currentAddress: [''],
				birthAddress: [''],
				linkedInUrl: [''],
			})
		);
	}

	public addReferenceGroup(control: AbstractControl): FormGroup {
		const group = this._fb.group({
			id: [null],
			range: [control.value.range, [Validators.required]],
			institution: [control.value.institution, Validators.required],
			name: [control.value.name, Validators.required],
		});
		control.reset();
		return group;
	}

	public buildReferenceGroup(reference: IUserReference): FormGroup {
		return this._fb.group({
			id: [reference.id],
			range: [[reference.startDate, reference.endDate], [Validators.required]],
			institution: [reference.institution, Validators.required],
			name: [reference.name, Validators.required],
		});
	}
}
